import useSWR from 'swr'
import storage from '@utils/localStorage'

const withUserLocation = (TargetComponent) => {
    return function (props) {
        const { data: user } = useSWR('user', storage)
        const coordinates = user?.location?.coordinates
        const city = user?.address?.city

        return <TargetComponent {...props} userLocation={props.userLocation || {
            city,
            coordinates,
            hasCity: !!city,
            hasCoordinates: !!coordinates,
        }} />
    }
}

export default withUserLocation